import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PhonelinkIcon from '@mui/icons-material/Phonelink';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import SpeedIcon from '@mui/icons-material/Speed';

const reasons = [
  { icon: <AutoAwesomeIcon sx={{ fontSize: 32, color: '#684df4' }} />, title: 'AI-Powered Lead Scoring', desc: 'Our smart algorithm ranks leads by conversion probability so counselors focus on the hottest prospects first.' },
  { icon: <LockOpenIcon sx={{ fontSize: 32, color: '#233098' }} />, title: 'Zero Data Lock-in', desc: 'Export all your data anytime. Your student records, reports and contacts always belong to you.' },
  { icon: <PhonelinkIcon sx={{ fontSize: 32, color: '#0ea5e9' }} />, title: 'Mobile App for Counselors', desc: 'Counselors can update leads, log calls and mark follow-ups on the go from their smartphones.' },
  { icon: <BarChartIcon sx={{ fontSize: 32, color: '#7c3aed' }} />, title: 'Real-Time Analytics', desc: 'Live dashboard showing admissions progress, counselor performance and fee collection at a glance.' },
  { icon: <GroupsIcon sx={{ fontSize: 32, color: '#059669' }} />, title: 'Multi-Branch Support', desc: 'Manage multiple campuses and departments under one login with separate reporting for each.' },
  { icon: <SpeedIcon sx={{ fontSize: 32, color: '#dc2626' }} />, title: 'Setup in 24 Hours', desc: 'Our team onboards your institution completely within 24 hours — training included, zero disruption.' },
];

const WhyChooseUs = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#684df4', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
          Why SN Info Systems
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#141d38', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '2.6rem' }, mb: 2 }}>
          Built for Institutions, Not Just Anyone
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: 16, maxWidth: 560, mx: 'auto', fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
          We've worked with 500+ institutions across India to build features that actually solve your daily problems.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {reasons.map((r, i) => (
          <Grid item xs={12} sm={6} md={4} key={i}>
            <Box sx={{
              p: 4, borderRadius: '20px', bgcolor: '#fafafa', border: '1px solid #f1f5f9',
              transition: 'all 0.3s',
              '&:hover': { bgcolor: '#fff', boxShadow: '0 12px 40px rgba(104,77,244,0.12)', transform: 'translateY(-4px)', borderColor: 'rgba(104,77,244,0.2)' },
            }}>
              <Box sx={{ width: 60, height: 60, borderRadius: '16px', bgcolor: 'rgba(104,77,244,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5 }}>
                {r.icon}
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 800, color: '#141d38', mb: 1.5, fontFamily: "'Montserrat', sans-serif", fontSize: '1rem' }}>{r.title}</Typography>
              <Typography sx={{ color: '#64748b', lineHeight: 1.75, fontFamily: "'Montserrat', sans-serif", fontSize: 14.5 }}>{r.desc}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default WhyChooseUs;
